export enum ServiceRequestType {
  none = "None",
  repairAndMainenance = "RepairAndMaintenance",
  expense = "Expense",
  accountsPayable = "AccountsPayable",
  dor = "DOR",
}
